import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	resultListItemAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	resultListItemAriaLabel: {
		id: 'command-palette.common.command-palette-search-result-list-item',
		defaultMessage: 'Command palette action item',
		description: 'The aria label for the command palette search result list item',
	},
});
